import { Flex } from 'antd';

import { Button, ButtonVariant, Modal, Typography } from '@/shared/ui';

import { Breakpoints, useMediaQuery } from '@/hooks/useMediaQuery';

interface Props {
  isOpen: boolean;
  onContinue: () => void;
  onClose: () => void;
}

export const InsurancePhoneChangeModal: React.FC<Props> = ({ isOpen, onContinue, onClose }) => {
  const isMobileSize = useMediaQuery(Breakpoints.SM);

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      title="Увага! При зміні номера телефона буде сформована нова оферта"
      footer={
        <Flex gap={12} vertical={isMobileSize}>
          <Button variant={ButtonVariant.SECONDARY} onClick={onClose}>
            Скасувати
          </Button>
          <Button
            onClick={() => {
              onClose();
              onContinue();
            }}
          >
            Редагувати
          </Button>
        </Flex>
      }
    >
      <Typography>Введені дані на попередніх кроках будуть збережені</Typography>
    </Modal>
  );
};
